import { render, staticRenderFns } from "./EkwateurGaz.vue?vue&type=template&id=67b1273e"
import script from "./EkwateurGaz.vue?vue&type=script&lang=js"
export * from "./EkwateurGaz.vue?vue&type=script&lang=js"
import style0 from "./EkwateurGaz.vue?vue&type=style&index=0&id=67b1273e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports